import moment from 'moment'
import React, { ChangeEvent, useContext, useEffect, useState } from 'react'
import { useLocation, useParams } from 'react-router-dom'
import {
    useAddCardPhotoMutation,
    useGetBlocksQuery,
    useGetCardQuery,
    usePostActivationLinkEmailMutation,
    usePostBlockMutation,
    usePostUnblockMutation,
    usePutCardMutation, useRemoveCardPhotoMutation,
} from '../../../../Redux/Api/Cards';
import { useGetTypeQuery, usePostTypeMutation, useDeleteTypeMutation } from '../../../../Redux/Api/Types';
import { all, isInt, isPositive, max, min } from '../../../../Utils/InValidation'
import { CardEditItem, CardResponseItem } from '../../../../Redux/Api/Request/Cards'
import { useAppSelector } from '../../../../Redux/store'
import BusyArea from '../../../Shared/BusyArea'
import Card from '../../../Shared/Card/Card'
import Button from '../../../Shared/Form/Button'
import CalendarInput from '../../../Shared/Form/CalendarInput'
import Form from '../../../Shared/Form/Form'
import Input, { FailedRequirements } from '../../../Shared/Form/Input'
import { ModalContext } from '../../../Shared/Modal/Modal'
import Title from '../../../Shared/Title'
import LoadingPage from '../../LoadingPage'
import { Hydra } from '../../../../Utils/Hydra'
import Constants from '../../../../Constants'
import StatusPopups from '../../../Shared/Form/StatusPopups'
import Page404 from '../../Page404'
import { useLazyGetOrganisationSettingsQuery, useLazyGetTypeDataQuery } from "../../../../Redux/Api/Organisations";
import { useTranslation } from "react-i18next";
import ImageInput from "../../../Shared/Form/ImageInput";
import { useUploadMutation } from "../../../../Redux/Api/Api";
import nlflag from '../../../../Assets/nl.svg'
import enflag from '../../../../Assets/en.svg'
import deflag from '../../../../Assets/de.svg'
import esflag from '../../../../Assets/es.svg'
import frflag from '../../../../Assets/fr.svg'
import { useNavigate } from 'react-router-dom';
import { faArrowLeft, faArrowRight, faEnvelope, faEnvelopeOpen, faEnvelopeOpenText, faFloppyDisk, faLock, faLockOpen, faPlus, faXmarkCircle, faLocationDot, faLocationDotSlash } from '@fortawesome/pro-solid-svg-icons';
import Dropdown from '../../../Shared/Form/Dropdown';
import CopyLink from '../../../Shared/Form/CopyLink';
import Map from '../../../Shared/Form/Map'
import PageMaxWidth from '../../../Shared/pageRenderers/PageMaxWidth';
import CardTypeSelectionList from '../../../Shared/Form/List/TypeSelectionList';
import { Chip } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const CardEditPage = () => {
    const modalContext = useContext(ModalContext)
    const { id } = useParams()
    const { t, i18n } = useTranslation()

    if (!id) return <Page404 />

    const org_id = useAppSelector((s) => s.organisation.id)!
    const [getOrganisationsSettings, { data: settings }] = useLazyGetOrganisationSettingsQuery()

    const [putCard] = usePutCardMutation()
    const [postBlock] = usePostBlockMutation()
    const [postUnblock] = usePostUnblockMutation()
    const [sendActivationLink] = usePostActivationLinkEmailMutation()
    const [postType] = usePostTypeMutation()
    const [deleteType] = useDeleteTypeMutation()
    const [uploadFile] = useUploadMutation()
    const [addPhoto] = useAddCardPhotoMutation()
    const [removePhoto] = useRemoveCardPhotoMutation()

    const { data, refetch: refetchCard, isError } = useGetCardQuery({
        id: id!,
    })

    const { data: blocks, refetch: refetchBlocks } = useGetBlocksQuery(id!)
    const [getOrganisationTypes, { data: orgTypes }] = useLazyGetTypeDataQuery();

    const [isBlocked, setIsBlocked] = useState(false)
    const [errorBlock, setErrorBlock] = useState('')
    const [errorMail, setErrorMail] = useState('')
    const [error, setError] = useState('')
    const [submitted, setSubmitted] = useState(false);
    const [submittedBlock, setSubmittedBlock] = useState(false);
    const [busy, setBusy] = useState(false)
    const [types, setTypes] = useState<Array<string>>([])
    const [newType, setNewType] = useState<string>('')

    const [check, setCheck] = useState('')
    const [successMessage, setSuccessMessage] = useState('')
    const [successAddMessage, setSuccessAddMessage] = useState('')
    const [email, setEmail] = useState('')
    const [activeFrom, setActiveFrom] = useState('')
    const [infinite, setInfinite] = useState(true)
    const [photo, setPhoto] = useState<Blob>()
    const [deletePhoto, setDeletePhoto] = useState(false)
    const [lastAction, setLastAction] = useState('')
    const [showMap, setShowMap] = useState(false)
    const [location, setLocation] = useState(data?.location || '')

    const navigate = useNavigate();

    const url = window.location.href;
    const isNew = url.includes("#new-card");

    useEffect(() => {
        if (sessionStorage.getItem('successMessage')) {
            setSuccessAddMessage(sessionStorage.getItem('successMessage')!);
            sessionStorage.removeItem('successMessage');
        }
    }, [org_id])

    useEffect(() => {
        if (!blocks) return

        setIsBlocked(blocks.length > 0)
    }, [blocks])

    useEffect(() => {
        if (org_id) {
            getOrganisationTypes({
                id: org_id
            })
            getOrganisationsSettings(org_id)
        }
    }, [org_id])

    const toMYSQLDate = (datestring: string | number) => {
        const date = new Date(datestring)
        return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
    }

    const requestDeleteType = async (id: string) => {
        if (id) {
            setBusy(true);
            await deleteType(id);

            refetchCard();
            getOrganisationTypes({ id: org_id });
            setBusy(false);
        }
    };


    const makeUnique = (arr: Array<string>) => {
        const unique = [...new Set(arr)]
        return unique
    }

    useEffect(() => {
        if (!data || !orgTypes) return

        let preTypes = []

        for (let type of data.types) {
            let item = orgTypes.find(x => x.id == type.slice('/api/types/'.length))
            if (item) {
                preTypes.push(item.name)
            }
        }

        setTypes(preTypes)
        setEmail(data.email || '')
        setActiveFrom(data.activeFrom)
        setLocation(data.location || '')
    }, [data, orgTypes])

    const makeNumberValid = (min: number, max: number, input: number) => {
        if (input >= min && input <= max) return input
        if (input <= min) return min
        if (input >= max) return max
    }

    const submit = async (data: {
        initials: string,
        lastname: string,
        image: File,
        email: string,
        numberOfPeople: number,
        dateOfBirth: string,
        location: string,
        telephoneNumber: string,
        department: string,
        activeFrom: string,
        activeUntil: string,
        membershipId: string,
        type: string,
        countryCode: string,
        discount: string,
        team: string
    }) => {
        setSubmitted(true);

        if (!settings) return;

        if (FailedRequirements(data, 'initials', 'lastname', 'email', 'activeFrom', 'membershipId')) {
            return setError(t('modal:error') as string);
        }

        if (data.numberOfPeople > settings.maxNumberOfPeople) {
            return setError(t('cards:edit:numberOfPeopleError', { number: settings.maxNumberOfPeople }) as string);

        }

        if (busy) return;

        setSubmitted(true)
        setBusy(true)
        setError('')
        setErrorBlock('')
        setSuccessMessage('')

        try {
            if (photo && lastAction === 'upload') {
                const uploadablePhoto = new File([photo], 'uploaded_photo');

                const upload_id = await uploadFile({
                    file: uploadablePhoto
                }).unwrap()

                await addPhoto({
                    card_id: id,
                    upload_id
                })
            }

            if (deletePhoto && lastAction === 'delete') {
                removePhoto(id)
            }

            const outData: Omit<CardEditItem, 'id' | 'organisationId'> = {
                initials: data.initials,
                lastname: data.lastname,
                membershipId: data.membershipId,
                email: data.email,
                activeFrom: toMYSQLDate(data.activeFrom),
                activeUntil: toMYSQLDate(data.activeUntil === '' ? '9999-01-01' : data.activeUntil),
                dateOfBirth: data.dateOfBirth,
                location: data.location,
                telephoneNumber: data.telephoneNumber,
                department: data.department,
                countryCode: data.countryCode,
                discount: data.discount,
                team: data.team,
                numberOfPeople: settings?.familyCards ? parseInt(String(makeNumberValid(1, settings.maxNumberOfPeople, data.numberOfPeople))) : 1, // typescript moment 🗿 -Michael Schuiling -Tim Dieters -Michael Schuiling - Tim Dieters
                types: []

            }

            let outTypes = []

            for (let type of types) {
                let item = orgTypes?.find(x => x.name == type)

                if (item) {
                    outData.types.push('/api/types/' + item.id)
                } else {
                    const id = await postType({
                        name: type.trim(),
                        organisation: org_id,
                        id: ''
                    }).unwrap()

                    outData.types.push('/api/types/' + id)
                }
            }

            await putCard({
                id,
                ...outData
            }).unwrap()

            refetchCard();
            getOrganisationTypes({ id: org_id });

            setSuccessMessage(t('cards:edit:success') as string)
            sessionStorage.setItem('cardChanged', 'true');
        } catch (e) {
            let err = e as Hydra.Error
            setError(err['hydra:description'])
            setBusy(false)
        }

        setTimeout(() => setBusy(false), 200)
    }

    const submitBlock = async (data: {
        reason: string,
        from: string,
        until: string,
        infinite: boolean
    }) => {
        if (busy) return

        setSubmittedBlock(true)
        setBusy(true)
        setError('')
        setErrorBlock('')
        setSuccessMessage('')

        try {
            let d = {
                from: toMYSQLDate(data.from),
                until: toMYSQLDate(data.until),
                reason: data.reason,
                infinite: infinite.toString()
            }

            if (infinite) {
                d = {
                    from: toMYSQLDate(new Date().toString()),
                    until: toMYSQLDate('9999-1-1'),
                    reason: data.reason,
                    infinite: infinite.toString()
                }
            }

            await postBlock([id!, d]).unwrap()
            refetchBlocks()

            sessionStorage.setItem('cardChanged', 'true');
            setSuccessMessage(t('cards:edit:successBlock') as string)
        } catch (e) {
            setErrorBlock(t('modal:error') as string)
            setBusy(false)
        }

        setTimeout(() => setBusy(false), 200)
    }

    const submitUnblock = async () => {
        if (busy) return

        setBusy(true)
        setError('')
        setErrorBlock('')
        setSuccessMessage('')

        try {
            await postUnblock(id!).unwrap()
            refetchBlocks()

            sessionStorage.setItem('cardChanged', 'true');
            setSuccessMessage(t('cards:edit:successUnblock') as string)
        } catch (e) {
            let err = e as Hydra.Error
            setErrorBlock(err['hydra:description'])
            setBusy(false)
        }

        setTimeout(() => setBusy(false), 200)
    }

    const submitEmail = async () => {
        if (!email) {
            return setErrorMail(t('cards:edit:noEmail') as string);
        }
        if (busy) return;

        setBusy(true);

        try {
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            const activeDate = new Date(activeFrom);
            activeDate.setHours(0, 0, 0, 0);

            if (activeDate > today) {
                setBusy(false);
                const formattedDate = activeDate.toLocaleDateString('nl-NL', {
                    day: '2-digit',
                    month: '2-digit',
                    year: 'numeric'
                });

                modalContext.withModal(
                    { title: t('cards:list:warningTitle'), body: t('cards:list:activationEmailWarning', { activeFrom: formattedDate }) },
                    handleDialogClose
                )();

                return;
            }

            await sendActivationEmail();
        } catch (e) {
            let err = e as Hydra.Error;
            setErrorMail(err['hydra:description']);
        } finally {
            setBusy(false);
        }
    };

    const handleDialogClose = async () => {
        setBusy(true);

        try {
            await sendActivationEmail();
        } catch (e) {
            let err = e as Hydra.Error;
            setErrorMail(err['hydra:description']);
        } finally {
            setBusy(false);
        }
    };

    const sendActivationEmail = async () => {
        setError('');
        setErrorBlock('');
        setSuccessMessage('');

        await sendActivationLink(id!);
        setSuccessMessage(t('cards:edit:emailSend') + email);
    };

    const createNewType = () => {
        if (!newType || newType.toLocaleLowerCase() === 'notype') return

        const arrayOfTypes = types
        arrayOfTypes.push(newType)

        setTypes(makeUnique(arrayOfTypes))
        setNewType('')
    }

    const removeType = (type: string) => {
        setTypes(makeUnique(types.filter(t => t != type)))
    }

    const handleInfinite = () => {
        setInfinite(!infinite)
    }

    const handleCrop = (blob: Blob | null) => {
        if (blob) {
            setPhoto(blob)
            setLastAction('upload')
        }
    }

    const handleRemovePhoto = () => {
        setDeletePhoto(true)
        setLastAction('delete')
    }

    function formatDate(until: string | null | undefined): string {
        if (!until) return '';
        const date = new Date(until);
        if (isNaN(date.getTime())) return '';
        const options: Intl.DateTimeFormatOptions = { day: 'numeric', month: 'long', year: 'numeric' };

        let lang = i18n.language;
        if (lang === 'en') {
            lang = 'en-GB';
        }

        return date.toLocaleDateString(lang, options);
    }

    if (isError) return <Page404 />
    if (!data) return <LoadingPage />

    return (
        <PageMaxWidth pageType='form'>
            <Title text={t('cards:edit:title')} textNotBold />
            <StatusPopups setText={setError} type='error' text={error} />
            <StatusPopups setText={setErrorBlock} type='error' text={errorBlock} />
            <StatusPopups setText={setErrorMail} type='error' text={errorMail} />
            <StatusPopups setText={setSuccessMessage} type='success' text={successMessage} />
            <StatusPopups setText={setSuccessAddMessage} type='success' text={successAddMessage} />
            <div className='flex flex-col md:flex-row flex-wrap items-start gap-2 mb-4 justify-between'>
                <div className='flex flex-col md:flex-row flex-wrap gap-2'>
                    <Button icon={faArrowLeft} title={isNew ? t('cards:edit:goToList') : t('cards:edit:backToList')} action={() => navigate('/' + i18n.language + '/dashboard/cards/list')} />
                    {isNew && <Button icon={faPlus} title={t('cards:edit:addNew')} action={() => navigate('/' + i18n.language + '/dashboard/cards/create')} />}
                    <Button icon={data.emailactivation ? faEnvelopeOpen : faEnvelope} action={submitEmail} title={data.emailactivation ? t('cards:edit:reActivationMail') : t('cards:edit:activationMail')} />
                </div>

            </div>
            <Card rounded outline>
                <div className='font-bold'>Download links</div>
                <CopyLink name='Google Play Store (Android):' copyItem={Constants.DOWNLOAD_URL_ANDROID} />
                <CopyLink name='App Store (Apple):' copyItem={Constants.DOWNLOAD_URL_IOS} />
                <div className='font-bold mt-2'>{t('cards:edit:activationCode')}</div>
                <CopyLink name={t('cards:edit:link')} copyItem={Constants.INVITE_LINK_PREFIX + data.token} />
                <CopyLink name={t('cards:edit:code')} copyItem={data.token || ''} />
                <CopyLink name={t('cards:edit:use')} copyItem={Constants.INVITE_CODE_LINK} />
            </Card>
            <BusyArea busy={busy}>
                <Form className='!mb-6 mt-6' submit={submit}>
                    <div className='flex flex-col 2xl:flex-row gap-4'>
                        <div className='w-full'>
                            <Input
                                submitted={submitted}
                                required
                                initial={data.initials}
                                invalidator={all(max(255))}
                                label={t('cards:list:initials')}
                                id='initials' />
                            <div className='flex gap-4 w-full'>
                                <Input
                                    className='w-full'
                                    submitted={submitted}
                                    required
                                    initial={data.lastname}
                                    invalidator={all(min(2), max(255))}
                                    label={t('cards:list:lastname')}
                                    id='lastname' />
                            </div>
                            <Input
                                submitted={submitted}
                                initial={data.email!}
                                valueChange={setEmail}
                                required
                                invalidator={all(max(255))}
                                label={t('cards:list:email')}
                                type='email'
                                id='email' />
                        </div>
                        {settings?.photo &&
                            <div className='w-full 2xl:w-[700px] mb-6 2xl:mb-0'>
                                <ImageInput withSave onCrop={handleCrop} onDelete={handleRemovePhoto} image={data.photo} />
                            </div>
                        }
                    </div>

                    {settings?.familyCards &&
                        <Input
                            submitted={submitted}
                            required
                            type='number'
                            initial={data.numberOfPeople ? data.numberOfPeople.toString() : '1'}
                            label={t('cards:edit:numberOfPeople')}
                            sublabel={'Max ' + settings.maxNumberOfPeople}
                            id='numberOfPeople' />
                    }
                    <CalendarInput
                        submitted={submitted}
                        required
                        initial={data.activeFrom}
                        label={t('cards:list:activeFrom')}
                        id='activeFrom' />
                    <CalendarInput
                        sublabel={t('cards:list:optional') as string}
                        initial={data.activeUntil != '9999-01-01T00:00:00+01:00' ? data.activeUntil : ''}
                        label={t('cards:list:activeUntil')}
                        id='activeUntil' />
                    <Input
                        submitted={submitted}
                        required
                        initial={data.membershipId}
                        invalidator={all(min(2), max(255))}
                        label={t('cards:list:number')}
                        id='membershipId' />
                    <Input
                        sublabel={t('cards:list:optional') as string}
                        initial={data.dateOfBirth}
                        label={t('cards:list:dateOfBirth')}
                        id='dateOfBirth' />

                    <div className='flex gap-2'>
                        <Input
                            label={t('cards:list:location')}
                            onChange={(e) => {
                                setLocation((e.target as HTMLInputElement).value);
                            }}
                            sublabel={t('cards:list:optional') as string}
                            value={location}
                            id='location'
                            className="w-full"
                        />
                        <div className='mt-[29px]'>
                            <Button
                                icon={showMap ? faLocationDotSlash : faLocationDot}
                                action={() => setShowMap(!showMap)}
                                nosubmit
                                title={t('cards:list:location')}
                            />
                        </div>
                    </div>

                    {showMap && (
                        <Map
                            setBusy={setBusy}
                            onChange={(e) => {
                                setLocation(e.locationName);
                            }}
                            initialLocation={location}
                        />
                    )}

                    <Input
                        sublabel={t('cards:list:optional') as string}
                        initial={data.telephoneNumber}
                        label={t('cards:list:phone')}
                        id='telephoneNumber' />
                    <Input
                        sublabel={t('cards:list:optional') as string}
                        initial={data.department}
                        label={t('cards:list:department')}
                        id='department' />

                    <Input
                        sublabel={t('cards:list:optional') as string}
                        initial={data.discount}
                        label={t('cards:list:discount')}
                        id='discount' />

                    <Input
                        sublabel={t('cards:list:optional') as string}
                        initial={data.team}
                        label={t('cards:list:team')}
                        id='team' />

                    <Dropdown
                        noSearch
                        noMarginBottom
                        className='mb-4'
                        label={t('cards:list:countryCode')}
                        id='countryCode'
                        initial={data.countryCode}
                        dropdownFullHeight
                        options={{
                            'NL': String(t('organisation:theme:NL')),
                            'EN': String(t('organisation:theme:ENG')),
                            'DE': String(t('organisation:theme:DE')),
                            'FR': String(t('organisation:theme:FR')),
                            'ES': String(t('organisation:theme:ES'))
                        }}
                        optionsImages={{
                            'NL': nlflag,
                            'EN': enflag,
                            'DE': deflag,
                            'FR': frflag,
                            'ES': esflag
                        }}
                    />

                    <div className="mb-4 flex flex-col md:flex-row lg:flex-col xl:flex-row gap-6">
                        <div className={`relative min-h-16 w-full md:w-[70%] lg:w-full xl:w-[70%]`}>
                            <p className='mb-1'>{t('cards:list:types')}</p>
                            <div className="flex gap-2 flex-wrap max-w-full">
                                {types.length > 0 ? (
                                    types.map((type, i) => (type.trim() !== "" && (
                                        <Chip
                                            key={i}
                                            label={type}
                                            onDelete={() => removeType(type)}
                                            deleteIcon={<FontAwesomeIcon icon={faXmarkCircle} />}
                                            variant="outlined"
                                            className='cursor-default'
                                        />
                                    )))
                                ) : (
                                    <p className="absolute top-1/2 -translate-y-1/2 left-1/2 -translate-x-1/2 text-[#5B6C79] text-md">
                                        {t('cards:edit:noType') as string}
                                    </p>
                                )}
                            </div>
                        </div>

                        <CardTypeSelectionList
                            className='w-full md:w-[30%] lg:w-full xl:w-[30%]'
                            orgTypes={orgTypes}
                            types={types}
                            newType={newType}
                            setNewType={setNewType}
                            createNewType={createNewType}
                            removeType={removeType}
                            setTypes={setTypes}
                            makeUnique={makeUnique}
                            onDelete={requestDeleteType}
                        />
                    </div>

                    <div className='flex flex-col md:flex-row items-start gap-4'>
                        <Button icon={faFloppyDisk} iconright title={t('cards:edit:save')} />
                        {(submitted || submittedBlock) && (<Button nosubmit icon={faArrowLeft} title={isNew ? t('cards:edit:goToList') : t('cards:edit:backToList')} action={() => navigate('/' + i18n.language + '/dashboard/cards/list')} />)}
                    </div>
                </Form>
                {isBlocked ? (
                    <>
                        <Title text={t('cards:edit:unblockCard')} />
                        <div className='mb-4'>
                            {t('cards:edit:blockedFor')} {blocks![0]?.reason},
                            <span className='opacity-40'> ({moment().diff(moment(blocks![0]?.from), 'hours') < 24 ? t('cards:edit:fromToday') : `${moment(blocks![0]?.from).fromNow()}`}) </span>
                            {t('cards:edit:until').toLocaleLowerCase()}
                            <span className='opacity-40'> ({blocks![0]?.until?.includes('9999') ? t('cards:edit:dateNone') : `${formatDate(blocks![0]?.until)}`}) </span>
                        </div>
                        <Button icon={faLockOpen} className='mb-32' action={modalContext.withModal({ title: t('modal:title'), body: t('modal:unblock') }, submitUnblock)} title={t('cards:edit:unblock')} />
                    </>
                ) : (
                    <Form className='' submit={submitBlock}>
                        <Title text={t('cards:edit:blockCard')} />
                        <Input
                            submitted={submittedBlock ? true : false}
                            required
                            large
                            label={t('cards:edit:reason')}
                            id='reason' />
                        <input type='checkbox' className='ml-1 h-4 w-4 mb-6 bg-transparent' checked={infinite} onKeyDown={(e) => e.key === 'Enter' && (e.preventDefault(), handleInfinite())} onChange={handleInfinite} /> <span className='ml-2 opacity-70 text-xl'>{t('cards:edit:blockForever')}</span>
                        {infinite ? (
                            <input type='hidden' value='infinite' name='cardType' />
                        ) : (
                            <div className=''>
                                <CalendarInput
                                    submitted={submittedBlock ? true : false}
                                    required
                                    label={t('cards:edit:from')}
                                    id='from' />
                                <CalendarInput
                                    submitted={submittedBlock ? true : false}
                                    required
                                    label={t('cards:edit:until')}
                                    id='until' />
                            </div>
                        )}
                        <Button icon={faLock} title={t('cards:edit:block')} />
                    </Form>
                )}
            </BusyArea>
        </PageMaxWidth>
    )
}

export default CardEditPage
